import TermsAndConditionsComponent, { TermsAndConditionsProps } from '../../../../components/terms-and-conditions';
import TermsSection from '../../../../components/sections/terms-section';

const TermsAndConditions = ({ terms }: TermsAndConditionsProps) => (
  <TermsSection termsComponent={<TermsAndConditionsComponent terms={terms} />} />
);

export default TermsAndConditions;
